import logger from '../logger';
var BemClassBuilder = /** @class */ (function () {
    function BemClassBuilder(component, element) {
        this.classNameList = [];
        if (!component || !component.__componentName) {
            logger.error('ClassBuilder requires a component in order to build correct class names');
        }
        this.baseClassName = component.__componentName;
        if (element && this.validateInput(element)) {
            this.baseClassName += "__" + element;
        }
        this.addClass(this.baseClassName, true);
    }
    BemClassBuilder.prototype.modifier = function (modificatorName, condition) {
        if (condition === void 0) { condition = true; }
        if (this.validateInput(modificatorName)) {
            this.addClass(this.baseClassName + "--" + modificatorName, condition);
        }
        return this;
    };
    BemClassBuilder.prototype.utility = function (utilityName, condition) {
        if (condition === void 0) { condition = true; }
        if (this.validateInput(utilityName)) {
            this.addClass("awsui-util-" + utilityName, condition);
        }
        return this;
    };
    BemClassBuilder.prototype.toString = function () {
        return this.classNameList.join(' ');
    };
    BemClassBuilder.prototype.validateInput = function (input) {
        if (input.trim()) {
            return true;
        }
        logger.error('You are using an empty string as a part of a class name');
        return false;
    };
    BemClassBuilder.prototype.addClass = function (className, condition) {
        if (this.classNameList.indexOf(className) !== -1) {
            logger.warn("You are adding a duplicate class name \"" + className + "\"");
            return;
        }
        if (condition) {
            this.classNameList.push(className);
        }
    };
    return BemClassBuilder;
}());
export default BemClassBuilder;
//# sourceMappingURL=bem.js.map